import {initDomPolyfills} from "./utils/domPolyfills/index";
import {initApp} from "./app";
import Likely from "ilyabirman-likely";

initDomPolyfills();

initApp();

Likely.initiate();
